import { Pagination } from "antd";
import "../Analytics.css";
import { useState } from "react";

function PostClicksTable(props: any) {
  const [localLoading, setLocalLoading] = useState(false);
  const { postClicks } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4; // Number of items per page

  // If no postClicks data, return null
  if (!postClicks || postClicks.length === 0) {
    return (
      <div className="no-data-message">
        No data available for this period
			</div>
    );
  }

  // Calculate the start and end indices for the current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = currentPage * pageSize;
  const handlePageChange = (page: number) => {
    setLocalLoading(true);
    setCurrentPage(page);
    setTimeout(() => {
      setLocalLoading(false);
    }, 100);
  };
  
  const renderMediaContent = (oneKey: any) => {
    // Check thumbnail first
    if (oneKey?.additionalData?.thumbnail) {
      const mediaUrls = oneKey?.additionalData?.thumbnail?.split(",") || [];
      const firstValidUrl = mediaUrls.find((url: string) => url && url.trim());
      if (firstValidUrl) {
        return (
          <img
            className="analytics-postClicks-thumbnail"
            src={firstValidUrl}
            alt="feed"
          />
        );
      }
    }

    // Then check media_url
    if (oneKey?.additionalData?.media_url) {
      const mediaUrls = oneKey?.additionalData?.media_url?.split(",") || [];
      const firstValidUrl = mediaUrls.find((url: string) => url && url.trim());
      if (firstValidUrl) {
        return (
          <img
            className="analytics-postClicks-thumbnail"
            src={firstValidUrl}
            alt="feed"
          />
        );
      }
    }

    // Then check image
    if (oneKey?.additionalData?.image) {
      const mediaUrls = oneKey?.additionalData?.image?.split(",") || [];
      const firstValidUrl = mediaUrls.find((url: string) => url && url.trim());
      if (firstValidUrl) {
        return (
          <img
            className="analytics-postClicks-thumbnail"
            src={firstValidUrl}
            alt="feed"
          />
        );
      }
    }
    // If no media found, show year
    return (
      <div className="analytics-postClicks-thumbnail-div-text">
        <div className="analytics-postClicks-thumbnail analytics-newsletter-thumbnail">
          {oneKey.name
            ? oneKey.name?oneKey?.additionalData?.platform:oneKey?.additionalData?.platform
            : oneKey?.additionalData?.post_date &&
              new Date(oneKey?.additionalData?.post_date).getFullYear()}
        </div>
      </div>
    );
  };
  return (
    <>
      {postClicks.length > pageSize ? (
        <>
          <div className="post-clicks-container">
            <table className="analytics-tables">
              <thead>
                <tr>
                  <th>Post</th>
                  <th>Clicks</th>
                </tr>
              </thead>
              <tbody>
                {postClicks
                  .slice(startIndex, endIndex)
                  .map((oneKey: any, index: any) => (
                    <tr key={index}>
                      <td>
                        <div className="analytics-postClicks-thumbnail-div">
                          {localLoading ? (
                            <img
                              className="analytics-postClicks-thumbnail"
                              src="/assets/dummy_video.png"
                              alt="feed"
                            />
                          ) : (
                            renderMediaContent(oneKey)
                          )}
                        </div>
                      </td>
                      <td>{oneKey.count}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <Pagination
              size="small"
              current={currentPage}
              total={postClicks.length}
              pageSize={pageSize}
              onChange={handlePageChange}
              className="text-center mt-4"
              align="center"
            />
          </div>
        </>
      ) : (
        <table className="analytics-tables">
          <thead>
            <tr>
              <th>Post</th>
              <th>Clicks</th>
            </tr>
          </thead>
          <tbody>
            {postClicks.map((oneKey: any, index: any) => (
              <tr key={index}>
                <td>
                  <div className="analytics-postClicks-thumbnail-div">
                    {localLoading ? (
                      <img
                        className="analytics-postClicks-thumbnail"
                        src="/assets/dummy_video.png"
                        alt="feed"
                      />
                    ) : (
                      renderMediaContent(oneKey)
                    )}
                  </div>
                </td>
                <td>{oneKey.count}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}

export default PostClicksTable;
